import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

const navItems = [
  { path: '/', icon: 'fas fa-home', label: 'Home' },
  { path: '/astrologer', icon: 'fas fa-comments', label: 'Chat' },
  { path: '/categories', icon: 'fas fa-store', label: 'Store' },
  { path: '/contactus', icon: 'fas fa-envelope', label: 'Contact' }
]

const MobileBottomNav = () => {
  const location = useLocation()
  
  useEffect(() => {
    // Add class to body for proper spacing
    document.body.classList.add('mobile-nav-active')
    
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('mobile-nav-active')
    }
  }, [])
  
  return (
    <nav className="mobile-bottom-nav d-flex d-lg-none" role="navigation" aria-label="Mobile navigation">
      {navItems.map(item=> (
        <Link 
          key={item.path} 
          to={item.path} 
          className={`nav-link flex-fill text-center ${location.pathname===item.path?'active':''}`}
          aria-label={item.label}
        > 
          <i className={item.icon} aria-hidden="true"></i>
          <span className="nav-label d-block">{item.label}</span>
        </Link>
      ))}
    </nav>
  )
}

export default MobileBottomNav 